// project_oep_single.js

const CONFIG = {}; 
const DATA = {};

CONFIG.bbox_n = 42.0095;
CONFIG.bbox_w = -124.4820;
CONFIG.bbox_s = 32.5295;
CONFIG.bbox_e = -114.1307;
CONFIG.min_zoom = 3;
CONFIG.max_zoom = 18;

CONFIG.no_image_text = 'Photo coming soon';

// string formatting functions
CONFIG.format = {
  'usd': function(n) { return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })},
  'number': function(n) {return parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})},
  'float': function(n) {return parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 1, maximumFractionDigits: 1})},
}

$(document).ready(function () {
  // start by getting image data
  Promise.all([
    initData('images'),
  ])
  .then(function(data) {
    initMap();
    initImageData(data[0]);
    initAfterCarousels();
    initCarouselFullScreenIcons(); 
  });
});

///////////////////////////////////////////////////////////////////////////////////
// Functions called on Doc ready
///////////////////////////////////////////////////////////////////////////////////

// Basic data init, returns a promise
function initData(url) {
  return new Promise(function(resolve, reject) {
    $.get(url, function(data) {
      resolve(data);
    });
  });
}

// init the fullscreen icons that are on every image
function initCarouselFullScreenIcons() {
  $('body').on('click', 'img.fullscreen', function() {
    // get the target and type from the image button that was clicked
    $('img#lightbox-image-single').hide();
    let target = $('div#lightbox-slideshow').empty();
    let type   = $(this).data('type');

    // check the number of images in this set, and either open a carousel, or the single image in a "lightbox"
    if (DATA[type].length > 1) {
      // get the active slide. Slightly different depending on the type
      let active_slide = $(`div.form-group.${type} div.carousel-item.active`).index();
      if (type == 'additional') active_slide = $(this).data('number');

      // call the carousel creating function
      createCarousel({
        type: type, 
        target: target, 
        image_type: $(window).width() > 767 ? 'large_url' : 'small_url', 
        active_slide: active_slide,
      });      

    } else {
      // single image: just replace the image source in lightbox-image-single
      $('img#lightbox-image-single').attr('src', $(this).data('bigimage')).show(); 
    }

    // open the modal
    $('div#modal-lightbox').modal('show');
  });
}

// init the fullscreen icons that are on every image
function initImageFullScreenIcons() {
  $('body').on('click', 'img.fullscreen', function() {
    // get the target and type from the image button that was clicked
    $('img#lightbox-image-single').hide();
    let target = $('div#lightbox-slideshow').empty();
    let type   = $(this).data('type');

    // single image: just replace the image source in lightbox-image-single
    $('img#lightbox-image-single').attr('src', $(this).data('bigimage')).show(); 

    // open the modal
    $('div#modal-lightbox').modal('show');
  });
}

function initImageData(data) {
  // get the after photos
  // ...there are no before photos for OEP
  DATA.after = data.filter(function(d) {
    return d.type == 'After';
  });

  // these are not before nor after, but instead tagged as "unknown"
  // and form a row of "other photos" below the before and after row
  DATA.additional = data.filter(function(d) {
    return d.type == 'Unknown';
  });
  // fake a "primary" attribute, so we can construct a carousel using the same API
  if (DATA.additional.length) DATA.additional[0]['primary'] = true;
}

// init the markup for After images or show a placeholder
function initAfterCarousels() {
  // if there is more than one After photo, show the primary one first,
  // and create a carousel to show the remaining images
  if (DATA.after.length > 1) {
    // show a text prompt "hint", if we have more than 1 after image
    $('#use-arrows').show();

    let options = { 
      type: 'after', 
      label: false, 
      target: $('div.form-group.after'), 
      fullscreen_icon: true,
      image_type: 'small_url', 
      active_slide: $('div.form-group.after div.carousel-item.active').index(),
    };
    createCarousel(options);

  } else if (DATA.after.length == 1) {
    // just show the one After image
    var target = $('div.form-group.after');
    var img = $('<img>', {
      src: DATA.after[0].small_url,
      alt: DATA.after[0].alt,
      'class': 'img-fluid img-width-100',
    }).appendTo(target);
    // append the fullscreen icon
    $('<img>', {
      src: BASE_URL + '/static/images/fullscreen.svg',
      'class': 'fullscreen single',
    }).attr('data-bigimage', $(window).width() > 767 ? DATA.after[0].large_url : DATA.after[0].small_url)
    .attr('data-type', 'after').appendTo(target);

  } else {
    // no After photo: Hide the fullscreen icon hint text
    $('div#hints').hide();

    // ... and show a blank image and icon
    var target = $('div.form-group.after');
    // no image on the record: append an empty image and div
    var badge_container = $('<div>', {'class': 'badge-container'}).appendTo(target);
    var badge = $('<div>', {'class': 'badge'}).appendTo(badge_container);
    $('<img>', {
      'class': 'img-fluid',
      src: BASE_URL + '/static/images/300x300.png'
    }).appendTo(badge);
    
    let text = $('<span>', {
      'class': 'no-image-text',
      text: CONFIG.no_image_text,
    }).appendTo(badge);

    let stack = $('<span>', {
      'class': 'fa-stack fa-2x',
    }).prependTo(text);

    $('<i>', {
      'class': 'fas fa-circle fa-stack-2x'
    }).appendTo(stack);

    $('<i>', {
      'class': 'fas fa-camera fa-stack-1x fa-inverse'
    }).appendTo(stack);
  }
}

function initMap() {
  CONFIG.map = L.map('map', {
    zoomControl: true,
    scrollWheelZoom: false,
    minZoom: CONFIG.min_zoom,
    maxZoom: CONFIG.max_zoom,
    keyboard: true,    
  })

  // add the static basemap layers: a satellite/photo layer, and a parks layer
  L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', { attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community', zIndex:100 }).addTo(CONFIG.map);

  // check if we have a LAT and LNG from the database. If we do, center the map on that location
  // and add a marker
  if (LAT != 0 && LNG != 0) {
  	CONFIG.map.setView([LAT, LNG], CONFIG.max_zoom - 1);
  	CONFIG.marker = L.marker([LAT, LNG]).addTo(CONFIG.map);
  } else {
  	// default view and marker location
  	CONFIG.map.fitBounds([ [CONFIG.bbox_s, CONFIG.bbox_w], [CONFIG.bbox_n, CONFIG.bbox_e] ]);
  	let center = CONFIG.map.getBounds().getCenter(); 
  	CONFIG.marker = L.marker([center.lat, center.lng]).addTo(CONFIG.map);
  	CONFIG.basemapbar.selectLayer('map');
  }
}


///////////////////////////////////////////////////////////////////////////////////
// Named functions
///////////////////////////////////////////////////////////////////////////////////

// there are two kinds of carousels here, both created with this one shared function 
// 1. Thumbnail carousels that open by default when there are multiple before or after images. See initBeforeAndAfterCarousels()
// 2. Modal carousels, that open when one clicks a "fullscreen" icon, and there are multiple images in the chosen set. See initCarouselFullScreenIcons()
function createCarousel(options) {
  // parse options
  let type = options.type;
  let label = options.label;
  let target = options.target;
  let fullscreen_icon = options.fullscreen_icon;
  let image_type = options.image_type;
  let active_slide = options.active_slide > -1 ? options.active_slide : 0;
  let data = DATA[type];
  let random = getRandomInt();
  var outer = $('<div>', {
    'class': 'carousel slide',
    id: `${type}-carousel-${random}`
  }).appendTo(target);
  // add carousel left and right indicators
  var list = $('<ol>', {'class': 'carousel-indicators'}).appendTo(outer);
  for (var i = 0; i < data.length; i++) {
    $('<li>').attr('data-target', `#${type}-carousel-${random}`).attr('data-slide-to', i).appendTo(list);
  }
  // append the fullscreen icon
  if (fullscreen_icon) {
    $('<img>', {
      src: BASE_URL + '/static/images/fullscreen.svg',
      'class': 'fullscreen',
    }).attr('data-type', type).appendTo(outer);
  }
  
  // add inner markup, and the slides themselves
  var inner = $('<div>', {'class': 'carousel-inner'}).appendTo(outer);
  // get the first or "primary" slide, and then all the others
  var first = data.filter(function(d) { return d.primary });
  var others = data.filter(function(d) { return ! d.primary });
  var first_slide = $('<div>', {'class': 'carousel-item'}).appendTo(inner);

  // append the first slide
  $('<img>', {
    src: first[0][image_type],
    alt: first[0].alt,
    'class': 'd-block',
  }).appendTo(first_slide);

  // append the other slides
  others.forEach(function(img, i) {
    var wrapper = $('<div>', {'class': 'carousel-item'}).appendTo(inner);
    $('<img>', {
      src: img[image_type],
      alt: img.alt,
      'class': 'd-block',
    }).attr('data-bigimage', img.large_url).appendTo(wrapper);
  });
  // append the 'dot' controls
  ['prev', 'next'].forEach(function(item) {
    var link = $('<a>', {
      'class': `carousel-control-${item}`,
      href: `#${type}-carousel-${random}`,
      role: 'button',
    }).attr('data-slide',`${item}`).appendTo(outer);
    $('<span>', {'class': `carousel-control-${item}-icon`}).appendTo(link); 
    $('<span>', {'class': 'sr-only', text: item}).appendTo(link); 
  });

  // choose the slide to be shown first via the "active" class
  // typically this will be the first slide
  inner.find('div.carousel-item').eq(active_slide).addClass('active');
  list.find('li').each(function() {
    let item = $(this);
    if (item.data('slide-to') == active_slide) item.addClass('active'); 
  });

  // markup done: Activate the carousel
  outer.carousel( {
    ride: false,
    interval: false,
  });

  // optional: append the photo label
  if (label) {
    $('<span>', {
      'class': `img-label ${type}`,
      text: `${type}`,
    }).appendTo(inner);
  }
}

///////////////////////////////////////////////////////////////////////////////////
// Shims and Utilities
///////////////////////////////////////////////////////////////////////////////////
// generic function to get a random integer in this hardcoded range
function getRandomInt() {
  let min = 10;
  let max = 1000000;
  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}
